export default __webpack_public_path__ + "static/media/16.a14bdd30.jpg";